export const hasDismissedBannerBetweenDates = ({ dismissedOn, startDate, endDate, }) => {
    return Boolean(startDate &&
        endDate &&
        dismissedOn &&
        new Date(startDate) < new Date(dismissedOn) &&
        new Date(endDate) > new Date(dismissedOn));
};
//# sourceMappingURL=hasDismissedBannerBetweenDates.js.map
// @zapier/universal-layout@12.2.5 (07fb29cf3)
